/**
 * Gates the phone-step conversion behaviour. Enabled only when both the
 * oneToOneSupplierConsent product flag and the captureBsaLeadsOnAbandonedFlows
 * flag are on: the latter is a hard prerequisite because it creates the held
 * phone-step lead the conversion rides on.
 *
 * @param {object} flags
 * @param {boolean} flags.oneToOneSupplierConsent
 * @param {boolean} flags.captureBsaLeadsOnAbandonedFlows
 * @returns {boolean} true only when both flags are enabled.
 */
const isPhoneStepConversionEnabled = ({
  oneToOneSupplierConsent,
  captureBsaLeadsOnAbandonedFlows,
}) => !!oneToOneSupplierConsent && !!captureBsaLeadsOnAbandonedFlows;

export default isPhoneStepConversionEnabled;
